import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
// START CUSTOMIZATION
import {
  changeLanguage,
  getContent,
  getNavigation,
} from '@plone/volto/actions';
import {
  BodyClass,
  flattenToAppURL,
  normalizeLanguageName,
} from '@plone/volto/helpers';
import { withServerErrorCode } from '@plone/volto/helpers/Utils/Utils';
import config from '@plone/volto/registry';
import { indexOf, slice, split } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Container } from 'semantic-ui-react';

import { Link } from 'react-router-dom';

/**
 * Not found function.
 * @function NotFound
 * @returns {string} Markup of the not found page.
 */
const NotFound = () => {
  const dispatch = useDispatch();

  const lang = useSelector((state) => state.intl.locale);
  const pathname = useLocation().pathname;

  useEffect(() => {
    const parts = pathname.split('/');
    dispatch(
      getContent(
        slice(parts, 0, parts[2] === 'site' ? 4 : 3).join('/'),
        null,
        'navRoot',
      ),
    )
      .then((resp) => {
        dispatch(
          getNavigation(
            flattenToAppURL(
              resp['@components'].nearest_inav_root.subsite['@id'] || `/`,
            ),
            config.settings.navDepth,
          ),
        );
      })
      .catch((err) => {
        dispatch(getNavigation(`/`, config.settings.navDepth));
      });

    // Get language
    const pathLang = split(pathname, '/')[1];

    if (indexOf(config.settings.supportedLanguages, pathLang) !== -1) {
      const langFileName = normalizeLanguageName(pathLang);
      import('@root/../locales/' + langFileName + '.json').then((locale) => {
        dispatch(changeLanguage(pathLang, locale.default));
      });
    }
  }, [dispatch, lang, pathname]);

  return (
    <Container className="view-wrapper">
      <BodyClass className="page-not-found" />
      <h1>
        <FormattedMessage
          id="This page does not seem to exist…"
          defaultMessage="This page does not seem to exist…"
        />
      </h1>
      <p className="description">
        <FormattedMessage
          id="We apologize for the inconvenience, but the page you were trying to access is not at this address. You can use the links below to help you find what you are looking for."
          defaultMessage="We apologize for the inconvenience, but the page you were trying to access is not at this address. You can use the links below to help you find what you are looking for."
        />
      </p>
      <p>
        <FormattedMessage
          id="If you are certain you have the correct web address but are encountering an error, please contact the {site_admin}."
          defaultMessage="If you are certain you have the correct web address but are encountering an error, please contact the {site_admin}."
          values={{
            site_admin: (
              <Link to="/contact-form">
                <FormattedMessage
                  id="Site Administration"
                  defaultMessage="Site Administration"
                />
              </Link>
            ),
          }}
        />
      </p>
      <p>
        <FormattedMessage id="Thank you." defaultMessage="Thank you." />
      </p>
    </Container>
  );
};

// END CUSTOMIZATION

export default withServerErrorCode(404)(NotFound);
